import { render, staticRenderFns } from "./InputTextTelephone.vue?vue&type=template&id=35f1c952&scoped=true&"
import script from "./InputTextTelephone.vue?vue&type=script&lang=js&"
export * from "./InputTextTelephone.vue?vue&type=script&lang=js&"
import style0 from "./InputTextTelephone.vue?vue&type=style&index=0&id=35f1c952&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f1c952",
  null
  
)

export default component.exports